import React, { useState, useEffect } from 'react';

const Clock = ({className}) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='d-none-sm'>
      <p className={`text-primary ${className}`}>{currentTime.toLocaleTimeString()}</p>
    </div>
  );
};

export default Clock;